import React, { useState, useEffect, useRef } from "react";
import { IconMap } from "./IconMap";
import { useLocation } from "react-router";
import { useOptimizedResize } from '../utils/performance';
import '../styles/LeadNav.css';

export const LeadNav = ({ sections, activeSection, setActiveSection, small }) => {
    const [minimize, setMinimize] = useState(window.innerWidth <= 768);
    const hoverTimeout = useRef(null);
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const sectionParam = sections.filter(section => section.name === params.get("section"))[0]?.id;
    
        if (sectionParam) {
            const sectionId = Number(sectionParam);
            if (!isNaN(sectionId)) {
                setActiveSection(sectionId);
            }
    
            params.delete("section");
            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.replaceState({}, "", newUrl.endsWith('?') ? newUrl.slice(0, -1) : newUrl);
        }
    }, [location]);

    useOptimizedResize(() => {

        if (window.innerWidth <= 768) {
            setMinimize(true);
        } else {
            setMinimize(false);
        }
    });

    const handleMinimize = () => {
        if (window.innerWidth <= 768) {
            setMinimize(true);
        } else {
            setMinimize(false);
        }
    }

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setMinimize(true);
        } else {
            setMinimize(false);
        }
    }, [activeSection]);

    const handleHover = () => {
        if (window.innerWidth > 768) {
            clearTimeout(hoverTimeout.current);
            hoverTimeout.current = setTimeout(() => {
                setMinimize(false);
            }, 500);
        }
    };
    
    const handleLeave = () => {
        clearTimeout(hoverTimeout.current);
        handleMinimize();
    };

    return (
        <div
            className={`lead-nav ${minimize ? 'minimized' : ''}${small ? ' small' : ''}`}
            onMouseOver={handleHover}
            onMouseLeave={handleLeave}
        >
            {sections?.map((section, index) => (
                <div 
                    key={section.id}
                    title={section.name} 
                    className={`lead-nav-item subtext large ${activeSection === section.id ? 'active' : ''} ${index === 0 ? ' s1' : ''}`} 
                    onClick={() => setActiveSection(section.id)}
                >
                    <span>{IconMap[section.icon] ? React.createElement(IconMap[section.icon]) : <></>}</span>{minimize ? '' : section.name}
                </div>
            ))}
        </div>
    );
};
